import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { MadinaBranch } from 'TYPES/madina';
import { getMadinaBranches } from 'network/services/madina';
import { setStoredBranch } from 'utils/branch';

export const BranchPicker = ({ open }: { open: boolean }) => {
  const navigate = useNavigate();
  const [branches, setBranches] = useState<MadinaBranch[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    setLoading(true);
    getMadinaBranches()
      .then(list => {
        if (!cancelled) setBranches(list);
      })
      .catch(() => {
        if (!cancelled) setBranches([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="mt-4 w-full text-left text-black">
      <p className="font-medium mb-2">Choose a store to continue</p>
      {loading ? <p className="text-sm text-gray-600">Loading stores...</p> : null}
      {!loading && branches.length === 0 ? <p className="text-sm text-gray-600">No stores are available right now.</p> : null}
      <div className="flex flex-col gap-2">
        {branches.map(branch => (
          <button
            key={branch.id}
            type="button"
            className="rounded border border-black/10 bg-white px-3 py-2 text-left"
            onClick={() => {
              setStoredBranch(branch.id, branch.name);
              navigate(`/?locationId=${branch.id}`);
            }}>
            {branch.name}
          </button>
        ))}
      </div>
    </div>
  );
};
